module.exports = __webpack_public_path__ + "static/output-fdbcbcd11216d4bb541e28a94fb88b4a.mp3";